import { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AppShell from '../components/AppShell';

const Chat = lazy(() => import('../pages/Chat/Chat'));
const Login = lazy(() => import('../pages/Login'));

// Ported HRMS Task pages
const TaskList = lazy(() => import('../hrms/pages/Task/TaskList'));
const TaskCreate = lazy(() => import('../hrms/pages/Task/TaskCreatePage'));
const TaskEdit = lazy(() => import('../hrms/pages/Task/TaskEditPage'));
const TaskDetails = lazy(() => import('../hrms/pages/Task/TaskDetails'));
const RecentlyDeleted = lazy(() => import('../hrms/pages/Task/RecentlyDeleted'));
const MyTasks = lazy(() => import('../hrms/pages/MyTasks/MyTasks'));
const TeamTasks = lazy(() => import('../hrms/pages/TeamTasks/TeamTasks'));
const TaskDashboard = lazy(() => import('../hrms/pages/TaskDashboard/TaskDashboard'));
const TaskReports = lazy(() => import('../hrms/pages/TaskReports'));

// Ported HRMS Calendar page
const CalendarPage = lazy(() => import('../hrms/pages/Calendar/Calendar'));

// Daily Planner (Todo)
const TodoPlanner = lazy(() => import('../hrms/pages/Todo/TodoPlanner'));
const TodoHistory = lazy(() => import('../hrms/pages/Todo/TodoHistory'));

// Projects
const ProjectsPage = lazy(() => import('../hrms/pages/Project/ProjectsPage'));
const ProjectDetails = lazy(() => import('../hrms/pages/Project/ProjectDetails'));

// Clients
const ClientsPage = lazy(() => import('../hrms/pages/Client/ClientsPage'));

function ProtectedShell() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell />;
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={<div className="flex h-screen items-center justify-center">Loading…</div>}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedShell />}>
            <Route path="/chat" element={<Chat />} />

            {/* Task Management — 5 sections */}
            <Route path="/todo" element={<TodoPlanner />} />
            <Route path="/todo/history" element={<TodoHistory />} />

            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />

            <Route path="/tasks" element={<Navigate to="/tasks/list" replace />} />
            <Route path="/tasks/list" element={<TaskList />} />
            <Route path="/tasks/create" element={<TaskCreate />} />
            <Route path="/tasks/dashboard" element={<TaskDashboard />} />
            <Route path="/tasks/my-tasks" element={<MyTasks />} />
            <Route path="/tasks/team-tasks" element={<TeamTasks />} />
            <Route path="/tasks/recently-deleted" element={<RecentlyDeleted />} />
            <Route path="/tasks/reports" element={<TaskReports />} />
            <Route path="/tasks/:id/edit" element={<TaskEdit />} />
            <Route path="/tasks/:id" element={<TaskDetails />} />

            <Route path="/clients" element={<ClientsPage />} />

            {/* Calendar */}
            <Route path="/calendar" element={<CalendarPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/chat" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
